import { SVGProps } from '@components/Icon/types';

export const List = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.2041 13.5107C21.2128 13.613 22 14.4643 22 15.5V19.5L21.9893 19.7041C21.8938 20.6457 21.1457 21.3938 20.2041 21.4893L20 21.5H4C2.89543 21.5 2 20.6046 2 19.5V15.5C2 14.3954 2.89543 13.5 4 13.5H20L20.2041 13.5107ZM4 14.9004C3.66863 14.9004 3.40039 15.1686 3.40039 15.5V19.5C3.40039 19.8314 3.66863 20.0996 4 20.0996H20C20.3314 20.0996 20.5996 19.8314 20.5996 19.5V15.5C20.5996 15.1686 20.3314 14.9004 20 14.9004H4Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.2041 2.51074C21.2128 2.613 22 3.46435 22 4.5V8.5L21.9893 8.7041C21.8938 9.64565 21.1457 10.3938 20.2041 10.4893L20 10.5H4C2.89543 10.5 2 9.60457 2 8.5V4.5C2 3.39543 2.89543 2.5 4 2.5H20L20.2041 2.51074ZM4 3.90039C3.66863 3.90039 3.40039 4.16863 3.40039 4.5V8.5C3.40039 8.83137 3.66863 9.09961 4 9.09961H20C20.3314 9.09961 20.5996 8.83137 20.5996 8.5V4.5C20.5996 4.16863 20.3314 3.90039 20 3.90039H4Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'list';
